var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHolidays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 720.9,
    height: 696.741,
    viewBox: "0 0 720.9 696.741",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1094.33 -383.837)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.992,
    cy: 29.539,
    rx: 48.992,
    ry: 29.539,
    transform: "translate(1492.159 457.01) rotate(-48.312)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.244,
    cy: 128.244,
    r: 128.244,
    transform: "translate(1511.484 402.613)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.933,327.857l-119.2,9.753a19.724,19.724,0,0,0-18.064,18.233l-4.451,61.422a19.724,19.724,0,0,0,19.672,21.149h53.725v2.882h21.614v-2.882h11.527v2.882H818.37v-2.882h11.522a19.724,19.724,0,0,0,19.7-18.714l3.65-71.175a19.723,19.723,0,0,0-21.306-20.668Z",
    transform: "translate(433.024 146.479)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.035,450.2,727.444,370.948,697.184,418.5s87.664,55.963,92.221,60.52c6.484,6.484,76.37,51.874,103.748,44.669S907.562,457.405,896.035,450.2Z",
    transform: "translate(444.698 218.266)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.624,449.388l-21.613,48.99H940.76l-16.252-51.872Z",
    transform: "translate(717.383 582.197)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.009,405.954s8.646,47.551,0,53.315,57.638,76.37,57.638,76.37l27.378-24.5,8.646-56.2s-25.937-36.024-14.409-67.725S867.009,405.954,867.009,405.954Z",
    transform: "translate(725.89 227.929)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.221,
    cy: 92.221,
    r: 92.221,
    transform: "translate(1526.616 463.85)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.859,464.919s-36.024-54.756-56.2-59.079-38.906-1.441-50.433,0-50.433-12.969-73.488-2.882,0,128.244,0,128.244S802.8,682.5,814.331,721.408s2.882,46.11-2.882,50.433S942.576,815.07,942.576,815.07h129.685s0-41.787,12.969-51.874,11.528-223.347,11.528-223.347l43.228-83.575s-7.2-31.7-37.465-33.142-57.271-17.327-57.271-17.327l-20.541,59.115Z",
    transform: "translate(634.472 265.508)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.592,415.272l-12.969-7.2s-24.5,1.441-28.819,0-59.079-18.732-80.693-8.646-36.024-2.882-36.024-2.882,70.607,60.52-15.85,79.252c0,0,1.441,7.2,23.055,11.528s25.937,8.646,34.583,15.85,25.937,14.41,37.465,17.291,64.843,34.886,70.606,29.122,0-33.445,0-33.445Z",
    transform: "translate(544.59 260.4)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.8,414.771l27.378,15.85s36.024,106.63,30.26,132.567-11.528,21.614-2.882,38.906,17.291,18.732,11.527,34.583-2.882,54.756-11.527,70.606-50.433,66.284-86.457-18.732S950.8,414.771,950.8,414.771Z",
    transform: "translate(796.276 291.16)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.368,688.347s-20.173-40.347-24.5-43.229-24.5-102.307-24.5-102.307,31.7-51.874,2.882-74.929c0,0,53.315-74.929,36.024-73.488s-51.874,56.2-51.874,56.2-7.925-2.161-5.043-13.689,13.689-52.595,5.043-54.036-25.937,60.52-25.937,60.52-35.3,64.122-24.5,86.457a278.433,278.433,0,0,0,21.614,36.023l24.5,178.678S996.636,802.182,1015.368,688.347Z",
    transform: "translate(783.586 238.049)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.85,
    cy: 7.205,
    rx: 15.85,
    ry: 7.205,
    transform: "translate(1239.865 486.905)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.173,480.609H724S679.33,466.2,679.33,433.057s12.969-100.866,53.315-99.425,2.882,90.78,2.882,90.78l24.424,9.967.072,30.38Z",
    transform: "translate(415 156.157)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.134,0c45.361,0,94.18,18.709,94.18,41.788S123.2,66.08,82.134,66.08,0,64.866,0,41.788,36.773,0,82.134,0Z",
    transform: "translate(1521.57 453.046)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.539,
    cy: 48.992,
    rx: 29.539,
    ry: 48.992,
    transform: "translate(1709.183 431.973) rotate(-25.902)",
    fill: "#090814"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidays);
export default __webpack_public_path__ + "static/media/holidays.a583abc668d698c8f1c7c249377855b9.svg";
export { ForwardRef as ReactComponent };